export class Pos {
  POS_ACTIONS = {
    POS_INFO: "ACTION_HOST_INFO",
    TRANSACTIONS_COUNT: "ACTION_TRN_COUNT",
    TRANSACTION_INFO: "ACTION_TRN_INFO",
  };

  POS_INFO_PARAMS = {
    HOST: "POS_HOST_RECORD",
  };

  TRANSACTION_INFO_PARAMS = {
    TRANSACTION_INDEX: "POS_TRANS_RECORD",
  };

  formatMessageObjectByAction(action, params = {}) {
    const message = { action, params: {} };

    for (const key in params) {
      if (params[key] && key.startsWith("POS_")) {
        message.params[key] = params[key];
      } else if (!key.startsWith("POS_")) {
        message[key] = params[key];
      }
    }

    return message;
  }
}
